import type { FlightStatus, ServerContextType } from './index.d';
import { getAccountFlightStatusSync } from './get-account-flight-status-sync';

export const IMAGE_RECOMMENDATION_TREATMENT_FLIGHT_ID = 2962;
export const IMAGE_RECOMMENDATION_CONTROL_FLIGHT_ID = 2963;

export const getImageRecommendationFlightStatus = (serverContext: ServerContextType): FlightStatus =>
  getAccountFlightStatusSync({
    flightsJson: serverContext?.AccountFlightAllocations,
    treatmentFlightId: IMAGE_RECOMMENDATION_TREATMENT_FLIGHT_ID,
    controlFlightId: IMAGE_RECOMMENDATION_CONTROL_FLIGHT_ID,
  });
